export default function LiquidationPriceTooltipContent() {
	return (
		<p>
			The estimated Oracle Price of the asset where your account can be
			liquidated, assuming the prices of your other assets/positions are
			constant.
		</p>
	);
}
